/** Clona metadata Meta no formato interno (components como objeto). */
export function normalizeMetaMetadata(metadata, templateType) {
  if (!metadata || typeof metadata !== "object") return null;

  const isMetadataFormat =
    metadata.components &&
    typeof metadata.components === "object" &&
    !Array.isArray(metadata.components);

  if (!isMetadataFormat) return null;

  const normalized = JSON.parse(JSON.stringify(metadata));
  const editor = templateType?.meta?.editor || {};
  const headerDef =
    editor.header && typeof editor.header === "object" ? editor.header : null;

  if (headerDef?.format === "IMAGE" && normalized.components?.header) {
    if (normalized.components.header.include == null) {
      normalized.components.header.include =
        headerDef.defaultInclude != null ? headerDef.defaultInclude : true;
    }
  }

  return normalized;
}

// O catalogo do backend (serializeTemplateTypes) ja entrega defaultMetadata
// pronto via buildDefaultMetadata. Usar somente essa fonte evita drift de
// reimplementacao no frontend.
export function buildDefaultMetaMetadata(templateType) {
  if (templateType?.defaultMetadata) {
    return normalizeMetaMetadata(templateType.defaultMetadata, templateType);
  }
  return null;
}

export function isAuthenticationEditor(editor) {
  return (
    editor?.body?.authentication === true ||
    editor?.category === "AUTHENTICATION"
  );
}

export function isMinimalEditor(editor) {
  return editor?.mode === "minimal";
}

export function headerSupported(editor) {
  return (
    editor?.header === true ||
    editor?.header?.supported === true ||
    editor?.header?.enabled === true
  );
}

export function headerUserToggle(editor) {
  return headerSupported(editor) && editor?.header?.userToggle === true;
}

export function headerInclude(metadata, editor) {
  const stored = metadata?.components?.header;
  if (stored?.include != null) return !!stored.include;
  const headerDef =
    editor?.header && typeof editor.header === "object" ? editor.header : null;
  if (headerDef?.defaultInclude != null) return headerDef.defaultInclude;
  return true;
}

// Regra Meta: a mensagem nao pode terminar com uma variavel. Pontuacao, espacos,
// quebras de linha e caracteres especiais (. * @ # $ % ? ! ( ) - + =) NAO contam
// como texto de fim (ex.: "{{party.name}}." continua invalido).
const TRAILING_NON_TEXT = /[.\s*@#$%?!()+=-]+$/u;

export function endsWithVariable(text) {
  if (typeof text !== "string") return false;
  const trimmed = text.replace(TRAILING_NON_TEXT, "");
  if (!trimmed) return false;
  return /{{\s*[\w.]+\s*}}$/.test(trimmed);
}

const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

export function renderPreviewText(text, variables) {
  if (!text) return "";
  let result = text;
  for (const v of variables || []) {
    const example = v.example ?? v.name;
    result = result.replace(
      new RegExp(`{{\\s*${escapeRegExp(v.name)}\\s*}}`, "g"),
      example
    );
  }
  return result;
}

export function buildAuthenticationPreview(metadata, templateType) {
  const variables = templateType?.variables || [];
  const codeExample =
    variables.find((v) => v.required)?.example ||
    variables.find((v) => v.name === "tokenCode")?.example ||
    "123456";
  const addSecurity = !!metadata?.components?.body?.add_security_recommendation;
  const minutes = metadata?.components?.footer?.code_expiration_minutes;

  let text = `*${codeExample}* é o seu código de verificação.`;
  if (addSecurity) {
    text += " Para sua segurança, não compartilhe este código.";
  }

  const footer =
    minutes != null ? `Este código expira em ${minutes} minutos.` : null;

  return {
    body: text,
    footer,
    buttonLabel: "Copiar código",
  };
}

export function headerEnabled(editor) {
  return headerSupported(editor);
}

export function isImageHeader(editor) {
  return headerSupported(editor) && editor?.header?.format === "IMAGE";
}

export function headerImageVariable(editor) {
  return editor?.header?.variable || "party.cover";
}

export function footerEnabled(editor) {
  if (isAuthenticationEditor(editor)) {
    return editor?.footer?.enabled === true;
  }
  return editor?.footer === true || editor?.footer?.enabled === true;
}

export function bodyEditable(editor) {
  if (isAuthenticationEditor(editor)) return false;
  return editor?.body !== false && editor?.body?.editable !== false;
}

export function footerExpirationEditable(editor) {
  return isAuthenticationEditor(editor) && editor?.footer?.editable !== false;
}
